<template>
  <v-col cols="12" md="6" lg="3">
    <v-card>
      <v-card-title>
        <p class="headline">{{ title }}</p>
      </v-card-title>
      <v-card-text>
        <p v-if="weight <= 0" class="display-3 green--text">
          <v-icon color="green">mdi-arrow-down</v-icon>
          {{ displayedWeight }} kg
        </p>
        <p v-else class="display-3 red--text">
          <v-icon color="red">mdi-arrow-up</v-icon>{{ displayedWeight }} kg
        </p>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "TrainingWeightCard",

  props: {
    title: String,
    weight: Number
  },

  computed: {
    displayedWeight: function () {
      return parseFloat(Math.abs(this.weight)).toFixed(1)
    }
  }
}
</script>